import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  ChangeDetectionStrategy,
  OnInit,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import {
  DataService,
  FormInputComponent,
  SharedModule,
  StringCustomFieldConfig,
} from "@vendure/admin-ui/core";
import { ID } from "@vendure/core";
import { gql } from "graphql-tag";
import { Subscription } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
@Component({
  standalone: true,
  imports: [SharedModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ng-select
      [multiple]="true"
      [(ngModel)]="options"
      appendTo="body"
      (change)="onChange($event)"
    >
      <ng-option
        *ngFor="let collection of allCollections"
        [value]="collection.id"
      >
        {{ collection.name }}
      </ng-option>
    </ng-select>
  `,
})
export class ProductCollectionCustomFieldComponent
  implements FormInputComponent<StringCustomFieldConfig>, OnInit, OnDestroy
{
  isListInput?: boolean | undefined = true;
  readonly!: boolean;
  formControl!: FormControl;
  config!: StringCustomFieldConfig;
  allCollections: { id: ID; name: string }[] = [];
  options: any[] = [];
  private routeSub!: Subscription;

  constructor(
    private dataService: DataService,
    private translationService: TranslateService,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {}

  ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }
  ngOnInit(): void {
    const productId = this.activatedRoute.snapshot.params.id;
    this.loadCollections();
    this.loadProductCollections(productId);

    // this.routeSub = this.router.events.subscribe((event) => {
    //   if (event instanceof NavigationEnd) {
    //     window.location.reload();
    //   }
    // });

    // Load product collections based on route parameters
    // this.activatedRoute.params.subscribe((params) => {
    //   const productId = params["id"];
    //   this.loadProductCollections(productId);
    //   this.loadCollections();
    // });
  }

  private loadCollections(): void {
    this.dataService
      .query(gql`
        query AllCollections {
          collections {
            items {
              id
              name
            }
          }
        }
      `)
      .single$.subscribe((data: any) => {
        if (data?.collections?.items) {
          this.allCollections = data.collections.items;
          console.log("loading all collections");
          this.cdr.markForCheck(); // Ensure UI updates
        }
      });
  }

  private loadProductCollections(productId: string): void {
    this.dataService
      .query(
        gql`
          query ProductCollections($id: ID!) {
            product(id: $id) {
              collections {
                id
              }
            }
          }
        `,
        { id: productId },
      )
      .single$.subscribe((data: any) => {
        console.log("loading product collections", data);
        if (data?.product?.collections?.length) {
          this.options = data.product.collections.map((i: any) => i.id);
          console.log(this.options);
          this.cdr.markForCheck(); // Ensure UI updates
        }
      });
  }

  onChange(event: string[]): void {
    console.log("changed", event);

    this.formControl.setValue(event.length ? event : ["0"]); //BUG: send impossible id if all were removed hacky way because i dont know why empty array or null does not work
    this.formControl.markAsDirty();
  }

  ngOnDestroy(): void {
    // Clean up subscriptions
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }
}
